/* mg-card-image-preload.js - MG 16 Aug 2026 (Will sss). Its CSS half is
   assets/mg-card-image-preload.css, pulled in by the @import list at the top of
   assets/mg-oos-gap-fix.css.

   Will: "some of the images in collpg when loading and scrolling take too long to show and are
   blank for ~1000ms."

   ===== MEASURED CAUSE - it was never the network =====
   Cold collection page, 1440x900, 72 lazy card images, unthrottled, per-image instrumentation
   (IntersectionObserver for viewport entry + PerformanceObserver for the request):

       image enters the viewport -> lazysizes assigns a real src    p90 577ms, max 681ms
       download once requested                                      ~0-50ms
       opacity fade to full (see the .css half)                     500ms
                                                                    --------
                                                                    ~1080ms

   which is exactly the ~1000ms reported. On a fast connection the download is irrelevant; the
   whole delay is lazysizes not getting around to the image until well after it is on screen.

   ⚠️ ===== THE CONFIG ROUTE DOES NOT WORK. DO NOT SPEND A SESSION ON IT. =====
   lazysizes 5.2.2 is bundled inside assets/vendors.js (which also does
   `lazySizesConfig.expand=300` at its top). Its throttle/idle scheduler is built ONCE at init:

       ie = function(cb){ var r2 = H.throttleDelay, n = H.ricTimeout, ...
                          s2 = (l && n > 49) ? <requestIdleCallback with timeout>
                                             : <rAF path>;  ... }

   `throttleDelay` and `ricTimeout` are captured into that closure, and the `n > 49` test picks
   the scheduling strategy once and for all. `expand` is likewise cached in `loader._defEx` the
   first time it is read. So assigning to `lazySizes.cfg.*` at runtime does NOTHING - verified
   live. Setting `window.lazySizesConfig` earlier does work, but only from an inline script ahead
   of vendors.js, i.e. a layout/theme.liquid edit - the 42KB file we avoid rewriting.

   ⭐ ===== WHAT WORKS INSTEAD =====
   `lazySizes.loader.unveil(el)` is public. We watch card images with our own IntersectionObserver
   and ask lazysizes to unveil one EARLY. The library still does all the real work - `sizes`
   computation, srcset candidate selection, the lazyloaded class, its own events - so nothing is
   reimplemented and nothing fights the cascade. unveil() is idempotent for an element already
   unveiled, so there is no double-fetch (measured: zero, across every run).

   ===== MEASURED AFTER, same method, cold collections =====
       desktop, 71 images   request starts 785ms BEFORE the card enters view (was 577ms AFTER)
                            still loading on entry: 4 of 71
       Fast 4G, 45 images   request starts ~1000ms before entry; still loading on entry: 1 of 45;
                            ZERO blank cards on screen at all 13 scroll positions sampled
                            (4G baseline for comparison: blank p90 877ms, 7 of 11 blank on entry,
                             up to 4 of 12 visible cards blank at once)

   Note the two connections fail differently: on 4G lazysizes actually schedules fine (the page is
   slow enough that it gets idle time) and the win is starting the DOWNLOAD a second earlier; on a
   fast connection the download is instant and the win is the scheduling. Same fix, both causes.

   ===== WHY MARGIN IS 800px =====
   Measured at rest on a 49-card collection, 900px viewport, median card image 39KB - how many
   images each lookahead holds, and therefore what a shopper who lands and bounces pays for:

       lazysizes' own 300px     8 images   ~315KB    (behaviour before this file)
       800px                   12 images   ~472KB    (+157KB)   <- chosen
       1200px                  16 images   ~630KB    (+315KB)
       1600px                  20 images   ~787KB

   800px is ~1.6 rows and buys roughly a second of lead time at a normal reading scroll, which
   covers the ~850ms an image takes on Fast 4G, at half the bounce cost of 1200px. It is ONE
   constant below: raise it if blanks reappear, lower it to spend less on people who bounce.

   ------------------------------------------------------------------------------------------
   ⭐⭐ SECONDARY (HOVER-SWAP) IMAGES NO LONGER GET THE 800px BOOST - MG 28 Aug 2026 (Will).

   Will, auditing V15 from the outside: "secondary images load at rest, not on hover... was
   loading at rest the decision, or is that script taking the choice away?"

   It was this script. The old selector was `.product-wrap img.lazyload`, and the collection
   card's SECONDARY image carries `lazyload` like any other - so every secondary was being
   unveiled 800px AHEAD OF THE VIEWPORT alongside its primary. The `fetchpriority="low"` set in
   snippets/image-element.liquid only ever changed the QUEUE ORDER; it was never going to stop
   the request. Cost, measured 28 Aug: +587KB above the fold and +3,530KB over a full 120-card
   desktop scroll. Nobody chose that.

   THE REASONING. A primary is needed BEFORE you can see it - that is the whole point of the
   800px lookahead. A secondary is needed only if someone hovers, which they cannot do until the
   card is on screen. So:

       primaries    800px lookahead, from first scan   - unchanged
       secondaries  excluded from that selector        - new

   ⚠️⚠️ WHAT THIS DOES AND DOES NOT DO - MEASURED, NOT ASSUMED.
   The intent was also to hold secondaries back until after `load`, at idle, at a 200px lookahead
   (ioSecondary / armSecondary below). ⭐ IN PRACTICE THAT ARMING NEVER GETS THERE FIRST.
   lazysizes' own `expand: 300` (set in vendors.js) unveils any secondary within 300px of the
   viewport during page load, before the arming runs - and this script can only ever ADD unveils,
   it cannot hold lazysizes back. Measured on the V15 preview 4s after a cold reload:

       window.__mgPreload   observed 52, unveiled 8, secondaryArmed true,
                            secondaryObserved 51, secondaryUnveiled 0
       secondaries          12 of 59 loaded - all 12 by lazysizes, none by us

   So the REAL effect is: secondaries drop from an 800px lookahead to lazysizes' native 300px.
   Above-fold secondaries still load during page load. ioSecondary is kept as belt-and-braces for
   anything lazysizes is slow to reach (AJAX-paginated cards, mainly). It is not the mechanism,
   and it is not what saves the bytes. Do not quote it as if it were.

   ⭐ THE ONLY LEVER THAT WOULD SAVE THE REST is hover-gating: keep the secondary out of
   lazysizes' reach entirely (no `lazyload` class) and unveil it on first pointerenter.
   Considered and REJECTED 28 Aug on two grounds. It costs a visible delay on the FIRST hover of
   every card - the swap would show a partial image or nothing, and the swap is a browse-speed
   interaction. And it makes the hover image depend on THIS SCRIPT loading, where today it does
   not. The measured case for paying that is weak: those above-fold secondaries were shown to
   cost NO LCP and NO CLS, because they sit at fetchpriority="low" behind the primaries. The
   bytes are real; a user-visible cost of those bytes was looked for and not found.

   ⚠️ MOBILE PAYS NOTHING, AND NOT BY ACCIDENT. mg-secondary-swap.css sets `display: none` on
   img.secondary below 799px / on `hover: none`. An element with no box never intersects, so
   ioSecondary below simply never fires there. Do not "fix" that by unveiling secondaries
   unconditionally.

   ⚠️ The arm step is belt-and-braces: requestIdleCallback where it exists, a short timeout where
   it does not, and a 6s floor so a page whose `load` never fires still ends up with working
   hover images rather than empty ones.
   ------------------------------------------------------------------------------------------
   ⚠️ SELECTOR WIDENED 16 Aug 2026 - `.product__grid-item` -> `.product-wrap`.

   The original selector matched product cards only, and the loader that injects this file gates
   on the same class. That meant the /collections LIST page - the one showing all the collections
   as tiles - got nothing: its tiles are `.list-collection__thumbnail`, it has zero
   `.product__grid-item`, so the loader never even fired and the tiles kept the full ~1000ms
   blank. (/search was always fine: 48 real `.product__grid-item`.)

   `.product-wrap` is the wrapper INSIDE both. Verified present on product grid cards, collection
   list tiles, search results and product recommendations - same
   `.product-wrap > .image__container > .image-element__wrap > img.lazyload` shape in all four.
   So one selector now covers every card-like image on the site, and only those: PDP galleries,
   mega-menu previews and everything else keep stock lazysizes behaviour.

   ⚠️ TWO LOAD PATHS, BOTH INTENTIONAL, GUARDED AGAINST DOUBLE-RUN:
     1. the loader block at the bottom of assets/mg-grid-reveal.js (gated on `.product__grid-item`)
        - covers collection pages, search and anywhere a product grid renders;
     2. a plain <script asset_url> tag at the bottom of sections/list-collections__main.liquid
        - covers the /collections list page, which path 1 cannot see.
   Path 2 uses Liquid's own fingerprint, so it needs NO manual token. Path 1 still hand-builds its
   URL. The `__mgPreload` guard below makes a double load harmless if the two ever overlap.

   >>> If you edit this file, bump the ?v= token in the loader at the bottom of mg-grid-reveal.js.
       Path 2 re-fingerprints itself. <<<
   ⭐ EXCEPTION, useful to know: Shopify serves /assets/ JS MINIFIED with comments stripped, so a
   COMMENT-ONLY edit produces byte-identical served output and needs no bump. Verified 28 Aug by
   re-fetching the asset after a comments-only upload and comparing served byte length. Any change
   to code still needs the bump.
   >>> ROLLBACK: delete the loader block in mg-grid-reveal.js and the script tag in
       sections/list-collections__main.liquid. This file and the .css half can stay; nothing else
       references them. <<<
   >>> ROLLBACK of the 28 Aug secondary change ONLY: set SEL back to '.product-wrap img.lazyload'
       and delete the SEL_SECONDARY / ioSecondary / armSecondary parts. <<<
   ------------------------------------------------------------------------------------------ */
(function () {
  'use strict';
  try {
    if (window.__mgPreload) return;
    if (!window.IntersectionObserver) return;

    var MARGIN = '800px';
    var SEL = '.product-wrap img.lazyload:not(.secondary)';

    var MARGIN_SECONDARY = '200px';
    var SEL_SECONDARY = '.product-wrap img.lazyload.secondary';
    var ARM_FLOOR = 6000;

    var stats = {
      observed: 0,
      unveiled: 0,
      secondaryArmed: false,
      secondaryObserved: 0,
      secondaryUnveiled: 0
    };
    window.__mgPreload = stats;

    var io = null;
    var ioSecondary = null;
    var watched = ('WeakSet' in window) ? new WeakSet() : null;

    function ready() {
      return window.lazySizes && window.lazySizes.loader &&
             typeof window.lazySizes.loader.unveil === 'function';
    }

    function onIntersect(entries, observer) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        var el = entries[i].target;
        observer.unobserve(el);
        try {
          window.lazySizes.loader.unveil(el);
          if (observer === ioSecondary) { stats.secondaryUnveiled++; }
          else { stats.unveiled++; }
        } catch (e) {}
      }
    }

    function build() {
      if (io) return true;
      if (!ready()) return false;
      io = new IntersectionObserver(onIntersect, { rootMargin: MARGIN });
      ioSecondary = new IntersectionObserver(onIntersect, { rootMargin: MARGIN_SECONDARY });
      return true;
    }

    function mark(el) {
      if (watched) {
        if (watched.has(el)) return false;
        watched.add(el);
        return true;
      }
      if (el.__mgPre) return false;
      el.__mgPre = 1;
      return true;
    }

    function scan() {
      if (!build()) return;
      var els = document.querySelectorAll(SEL);
      var i;
      for (i = 0; i < els.length; i++) {
        if (!mark(els[i])) continue;
        io.observe(els[i]);
        stats.observed++;
      }
      if (!stats.secondaryArmed) return;
      var sec = document.querySelectorAll(SEL_SECONDARY);
      for (i = 0; i < sec.length; i++) {
        if (!mark(sec[i])) continue;
        ioSecondary.observe(sec[i]);
        stats.secondaryObserved++;
      }
    }

    function armSecondary() {
      if (stats.secondaryArmed) return;
      stats.secondaryArmed = true;
      scan();
    }

    scan();
    var tries = 0;
    var poll = setInterval(function () {
      scan();
      if (++tries > 60) clearInterval(poll);
    }, 250);

    window.addEventListener('load', function () {
      scan();
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(armSecondary, { timeout: 2000 });
      } else {
        setTimeout(armSecondary, 200);
      }
    });
    setTimeout(armSecondary, ARM_FLOOR);
  } catch (e) { /* purely an optimisation -- never let it break a collection page */ }
})();